import Grid from "./Grid.js"
import AI from "./AI.js";
import Peace from "./Peace.js";
const isDebug = false;//ログ表示
export default class Stage {

    constructor(sum) {
        this.grid = new Grid(6, 6);
        this.maxsum = sum;
        this.hit = false;//ヒントブロックが存在？
        this.hintArray = new Array()   //ブロックNo
        this.hintArray2 = new Array()  //ブロック取得配列
        this.hintHistory = null
    }
    setHintArray2() {
        while (this, this.hintArray2.pop());// clear array
        //this.hintArray2 = new Array(this.blocknum).fill().map(u => { return []; })
        //a = new Array(ARRAY_SIZE).fill().map(u => { return []; });
        for (var index = 0; index < this.blocknum; index++) {
            this.hintArray2.push({ index: index, use: 0, count: 0 })
        }
        this.hintArray.forEach((array, index) => {
            array.forEach((value, index2) => {
                this.hintArray2[value].count++
                //console.log( index + JSON.stringify(value));
            });
        });
    }
    isBlockEmpty(no) {
        for (var x = 0; x < 6; x++) {
            for (var y = 0; y < 6; y++) {
                if (no == this.hintArray[x][y] && this.grid.cells[x][y] == 0) {
                    return false
                }
            }
        }
        return true
    }
    //set blocknum and hintarray
    procStage(array) {
        if(array){
        this.hintArray = array
        }
        //this.setHintArray(array)
        this.blocknum = 0;
        this.hintArray.forEach((array, index) => {
            array.forEach((value, index2) => {
                if (this.blocknum < value) {
                    this.blocknum = value
                }
                //console.log( index + JSON.stringify(value));
            });
        });
        this.blocknum++;//ブロックの個数にする
        this.setHintArray2();
        this.setBlockNumber()
    }

    setBlockNumber(){
        this.hintArray2.forEach((array, index) => {
            this.fillBlockNumber(array)
        });
    }
    fillBlockNumber(array){
        var count = array.count
        var index = array.index
        var no = 0
        var sum = this.maxsum
        this.hintArray.forEach((value, y) => {

            value.forEach((value2, x) => {
                if (value2 == index) {
                    if(no == (count - 1)){
                        this.grid.cells[y][x] = sum 
                        this.consolelog("next"+index+","+sum) 
                    }else{
                        let next = this.nextNumber(sum,no++,count)
                        this.grid.cells[y][x] = next
                        sum -=next
                        this.consolelog("next"+index+","+next)
                    }
                }
            }
            );
            this.consolelog("####")

        });
    }
    // no ブロッック内の空のマスに何をうめるか
    // 残数を最低１として　次の数は　最大数ー残数　より小さい数をランダムで選ぶ
    nextNumber(sum ,no,count){
        var rest = count - no
        var nextno = Math.floor(Math.random()* (sum - rest)) + 1;
        return nextno
    }
    //新規ステージ作成する
    createStage() {
        if(false){
          //デバッグ用
        this.copyGrid([
                [5,5,5,5,6,6],
                [7,7,1,1,3,6],
                [4,7,7,7,3,3],
                [4,4,4,2,2,3],
                [8,2,2,2,9,9],
                [8,8,8,9,9,9]
               ]);
        this.hintArray.length = 0;
        this.grid.cells.forEach((value, y) => {
                   this.hintArray.push(value.map(u => { return u - 1 ; }))
        });
        this.copyGrid([
            [1,4,2,3,3,5],
            [4,1,1,9,5,2],
            [4,1,1,3,1,2],
            [3,1,2,3,2,2],
            [2,1,2,2,1,1],
            [2,4,2,3,2,3]
           ]);
           this.blocknum = 9;//ブロックの個数にする
       this.setHintArray2();
       //this.setBlockNumber()
            return
        }
        //var grid = new Grid(22, 10);
        //this.dumpGrid()
        //var ai = new AI(0.510066, 0.760666, 0.35663, 0.184483);
        var ai = new AI(0.510066, 0.760666, 0.35663, 0.184483);
        //for(var i=0;i<4;i++){
        var ailoop = 3;

        do {
            //console.log("retry=" + ailoop)
            this.grid.clean()
            //this.heightWeight = heightWeight;
            //this.linesWeight = linesWeight;
            //this.holesWeight = holesWeight;
            //this.bumpinessWeight = bumpinessWeight;
            ai.heightWeight = 0.510066
            ai.holesWeight = 0.35663;
            var ansewid = 0;
            //暫定
            while (true) {
                if(this.maxsum == 10){
                    var randomIndex = Math.floor(Math.random() * 9);
                }
                if(this.maxsum == 20){
                    var randomIndex = Math.floor(Math.random() * 16) + 1;//Math.floor(Math.random() * 9);
                }
                if(this.maxsum == 30){
                    var randomIndex = Math.floor(Math.random() * (27 - 9)) + 9;//Math.floor(Math.random() * 9);
                }
                this.consolelog(randomIndex)
                let workingPieces = [Peace.fromIndex(randomIndex)];
                let workingPiece = ai.best(this.grid, workingPieces);
                if (workingPiece) {
                    ansewid++
                    workingPiece.fill(ansewid)
                    this.grid.addPiece(workingPiece)
                } else {
                    break;
                }
            }
            /* this.copyGrid([[0,0,0,0,0,0],
              [0,0,5,0,7,0],
              [0,0,5,6,7,7],
              [4,4,5,6,0,7],
              [3,4,5,6,6,1],
              ansewid=7 
                */
            //this.dumpGrid()
            //残りの処理
            if (true) {
                ai.holesWeight = 0.1;
                ai.heightWeight = 0.01
                while (true) {
                    var bestpeace = new Object()
                    bestpeace.score = null;
                    var bestno = 0;
                    switch(this.maxsum){
                        case 10:
                            var start = 0,end = 9;
                            break;
                        case 20:
                            var start = 1,end = 17;
                            break;
                        case 30:
                             var start = 5,end = 27;
                            break;
                    }
                    for (var pno = start; pno < end; pno++) {
                        //for (var pno = 1; pno < 17; pno++) {
                        //for (var pno = 5; pno < 27; pno++) {
                        let randomIndex = pno;//Math.floor(Math.random() * 6);
                        let workingPieces = [Peace.fromIndex(randomIndex)];
                        let workingPiece = ai._best2(this.grid, workingPieces, 0);
                        if (workingPiece.piece) {
                            this.consolelog(pno + "=" + workingPiece.score + "," + workingPiece.piece.column + "," + workingPiece.piece.row)
                        }
                        if (workingPiece.piece && (workingPiece.score > bestpeace.score || bestpeace.score == null)) {

                            //this.grid.addPiece(workingPiece)
                            bestpeace = workingPiece
                            bestno = pno
                        }
                    }
                    if (bestpeace.piece) {
                        this.consolelog("decide=" + bestno + "," + bestpeace.piece.column + "," + bestpeace.piece.row)
                        ansewid++
                        bestpeace.piece.fill(ansewid)
                        this.grid.addPiece(bestpeace.piece)
                    } else {
                        //this.dumpGrid()
                        break;
                    }
                }
            }

            //this.dumpGrid()
            //穴を埋める
            //console.log(this.checkExtend(3,2))
            this.fillGrid()
            this.dumpGrid()
        } while (this.grid.countHoles() > 0 && ailoop++ < 5);

        // this.checkGrid()
        this.createHintArray();
        this.dumpGrid()
    }
    //
    createHintArray(){
        this.hintArray.length = 0;
        this.grid.cells.forEach((value, y) => {
            this.hintArray.push(value.map(u => { return u - 1 ; }))
        });
        this.procStage();
    }
    //穴の空いている部分をブロックを拡張して埋める
    fillGrid() {
        this.grid.cells.forEach((value, y) => {

            value.forEach((value, x) => {
                if (value == 0) {
                    if (x > 0 && this.checkExtend(x - 1, y)) {
                        this.consolelog("space0=" + x + "," + y + "," + this.grid.cells[y][x - 1]);
                        this.grid.cells[y][x] = this.grid.cells[y][x - 1]
                    } else if (x < (this.grid.cells.length - 1) && this.checkExtend(x + 1, y)) {
                        this.consolelog("space1=" + x + "," + y + "," + this.grid.cells[y][x + 1]);
                        this.grid.cells[y][x] = this.grid.cells[y][x + 1]
                    } else if (y > 0 && this.checkExtend(x, y - 1)) {
                        this.consolelog("space2=" + x + "," + y + "," + this.grid.cells[y - 1][x]);
                        this.grid.cells[y][x] = this.grid.cells[y - 1][x]
                    } else if (y < (this.grid.cells.length - 1) && this.checkExtend(x, y + 1)) {
                        this.consolelog("space3=" + x + "," + y + "," + this.grid.cells[y + 1][x]);
                        this.grid.cells[y][x] = this.grid.cells[y + 1][x]
                    }
                }
            }
            );

        });
    }
    //デバッグ用のログ表示
    consolelog(val) {
        if(isDebug)
         console.log(val)
    }
    //　拡張可能かは　おそらく　上下左右に　同じブロックでない領域が３つあるかで判定できる
    checkExtend(x, y) {
        var no = this.grid.cells[y][x]
        if (no == 0) return false
        this.consolelog("check=" + x + "," + y);
        var sum = 0;
        sum = x > 0 ? (this.grid.cells[y][x - 1] != no ? 1 : 0) : 1;
        this.consolelog("0=" + sum)
        sum += x < (this.grid.cells.length - 1) ? (this.grid.cells[y][x + 1] != no ? 1 : 0) : 1;
        this.consolelog("1=" + sum)
        sum += y > 0 ? (this.grid.cells[y - 1][x] != no ? 1 : 0) : 1;
        this.consolelog("2=" + sum)
        sum += y < (this.grid.cells.length - 1) ? (this.grid.cells[y + 1][x] != no ? 1 : 0) : 1;
        this.consolelog("3=" + sum);

        return sum > 2
    }
    //０があるか　
    checkGrid() {
        this.grid.cells.forEach(function (value, y) {

            value.forEach(function (value, x) {
                if (value == 0) {
                    this.consolelog("space=" + x + "," + y);
                }
            }
            );

        });
    }
    _copy(array_s,array_d){
        array_d.forEach((value, index) => {
            array_d[index] = array_s[index]
            //console.log( index + JSON.stringify(value));

        });
    }
    //ステージ配列のコピー
    copyGrid(array) {
        //console.log(JSON.stringify(this.grid.cells))
        this._copy(array,this.grid.cells)
        /*
        this.grid.cells.forEach((value, index) => {
            this.grid.cells[index] = array[index]
            //console.log( index + JSON.stringify(value));

        });
        */
        
    }
    //ヒント作成　
    isStartBlock(x, y) {
        this.addBlockNumber(x, y, 0, [])
    }
　　//ヒント配列作成用　再帰処理
    addBlockNumber(x, y, sum, history) {
        try {
            //マスが空の場合検索終了
            if (this.grid.cells[y][x] == 0) return false;
            //マスがすでに移動済みの場合検索終了　一筆書き
            const result = history.filter(position => position.x == x && position.y == y);
            if (result.length > 0) return false;
            //history.push({ x: x, y: y })
            //初回
            //if(history.length == 0){
            history.push({ x: x, y: y })
            //}
            //マスの数字を足す
            sum += this.grid.cells[y][x];
            //設定合計値になったら　履歴を残し　終了
            if (sum == this.maxsum) {
                this.hit = true;
                this.hintHistory = history.concat();
                //console.log("hit=" + JSON.stringify(history))
                return true
                //設定合計値以上になったら　終了
            } else if (sum > this.maxsum) {
                return false;
            } else {
                //マスをひとつ移動しさらに探索をすすめる
                if (x < (this.grid.cells.length - 1)) {
                    //history.push({ x: x + 1, y: y })
                    let l = history.length
                    this.addBlockNumber(x + 1, y, sum, history)
                    if (l < history.length) {
                        history.pop();
                    }
                }
                if (x > 0) {
                    let l = history.length
                    //history.push({ x: x - 1, y: y })
                    this.addBlockNumber(x - 1, y, sum, history)
                    if (l < history.length)
                        history.pop();
                }
                if (y < (this.grid.cells.length - 1)) {
                    let l = history.length
                    //history.push({ x: x, y: y + 1 })
                    this.addBlockNumber(x, y + 1, sum, history)
                    if (l < history.length)
                        history.pop();
                }
                if (y > 0) {
                    let l = history.length
                    //history.push({ x: x, y: y - 1 })
                    this.addBlockNumber(x, y - 1, sum, history)
                    if (l < history.length)
                        history.pop();
                }
            }
        } catch (e) {
            tthis.consolelog("err" + x + "," + y)

        }
    }
    dumpGrid() {
        //console.log(JSON.stringify(this.stage.grid.cells))
        var _self = this
        this.grid.cells.forEach(function (value, index) {

            _self.consolelog(index + JSON.stringify(value));

        });
        this.consolelog("######")
    }
}   